<template>
    <div>
        <v-container>
            <v-row>
                <v-col
                    v-for="(item, id) in Banners"
                    :key="id"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="3"
                    xl="3"
                    align="center"
                >
                    <router-link
                        :to="{ name: 'Ofertas', query: { lab: item.grupo1 } }"
                    >
                        <v-img
                            @mouseover="setHover(false, item)"
                            @mouseleave="setHover(true, item)"
                            height="100%"
                            :src="item.hover ? item.src : item.src2"
                            :alt="item.alt"
                            style="cursor: pointer;"
                        />
                    </router-link>
                </v-col>
            </v-row>
        </v-container>
        <v-divider class="azul" />
        <a href="https://bit.ly/3dbSdL8" target="_blank">
            <v-img
                id="banner-labbi"
                src="img/banners/banner-labbi-1338x120.png"
                alt="Banner Labbi"
            />
        </a>
    </div>
</template>

<script>
export default {
    data: () => ({
        Banners: [
            {
                alt: 'Banner Pfizer',
                src: 'img/banners/farmapfizer-blue.svg',
                src2: 'img/banners/farmapfizer-color.svg',
                grupo1: 'PFIZ',
                hover: true
            },
            {
                alt: 'Banner Nutricia',
                src: 'img/banners/nutriciabago-blue.svg',
                src2: 'img/banners/nutriciabago-color.svg',
                grupo1: 'NUTR',
                hover: true
            },
            {
                alt: 'Banner Bayer',
                src: 'img/banners/bayer-blue.svg',
                src2: 'img/banners/bayer-color.svg',
                grupo1: 'BAYE',
                hover: true
            },
            {
                alt: 'Banner Sanofi',
                src: 'img/banners/sanofi-blue.svg',
                src2: 'img/banners/sanofi-color.svg',
                grupo1: 'SANO',
                hover: true
            }
        ]
    }),
    methods: {
        setHover(val, i) {
            i.hover = val;
        }
    }
};
</script>
<style scoped>
@media (max-width: 599px) {
    #banner-labbi {
        content: url('../../public/img/banners/banner-labbi-1300x400.png');
    }
}
@media (min-width: 600px) {
    #banner-labbi {
        max-height: 150px;
    }
}
</style>
